import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { Subject } from 'rxjs';
import { Asset } from '../classes/asset';
import { DrawVan } from '../classes/draw-van';
import { OutboundAircraftAddEvent } from '../classes/outbound-aircraft-add-event';
import { VanEventAddEvent } from '../classes/vanEvent-addEvent';
import { ProfileService } from './profile.service';



const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const vanStrokeColor = "#000";


@Injectable({
  providedIn: 'root'
})
export class MapIconService {
  unsubscribe$: Subject<boolean> = new Subject();
  public adId = '';
  constructor(private profileService: ProfileService) {
  //  this.subscribeToProfile();
   }

  setDefaultIconOptions(){
    return L.icon({
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });
  }

  makeVanIcon(row: Asset): L.DivIcon {
    let heading = row.position.heading;
    return L.divIcon({
      html:`<div class="map-label">
              <div class="heading-arrow-origin">
                <div class="heading-arrow-container" style="transform: rotate(${heading}deg);-webkit-transform: rotate(${heading}deg)">
                </div>
              </div>
              <div style="bottom: -2px; border:solid 1px #000; border-radius:100%; left: -50%; position:relative" >
                <div class="map-van-marker-div-icon"
                  style="background-color:${row.metadata.vanColor};
                  border-color:${row.metadata.vanFontColor};
                  color:${row.metadata.vanFontColor}">
                  ${row.metadata.driverInitials}
                </div>
              </div>
              <div class="map-label-arrow"></div>
            </div>`,
      className: 'dummy',
      popupAnchor: [0, -30]
   });
  }


  makeVanSvgIcon(row: VanEventAddEvent): L.DivIcon {
    const vanImageForMarker = this.drawVan({
      bgColor     : row.vanColor,
      initials    : row.driverInitials,
      fontColor   : row.vanFontColor,
      strokeColor : vanStrokeColor,
      drawFor     :'otherVans'
    });
    return L.divIcon({
      className   : 'site-marker van-marker',
      html        : vanImageForMarker,
      popupAnchor : [-5, -25],
      iconSize    : new L.Point(44, 66)
    });
  }



  drawVan(args: DrawVan){
    let vanDriverInitialsPref = (args.initials != null && args.initials != undefined) ? args.initials.toUpperCase() : "UPS";
    let vanWidth = args.width != undefined ? args.width : "35px";
    let vanHeight = args.height != undefined ? args.height : "43px";
    let svgSizeMarkup = '<svg width=\"'+vanWidth+'\" id=\"svg3\" height=\"'+vanHeight+'\" preserveAspectRatio="xMinYMin meet" viewBox=\"0 0 55 66\" version=\"1.1\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlns:xlink=\"http:\/\/www.w3.org\/1999\/xlink\" xmlns:sketch=\"http:\/\/www.bohemiancoding.com\/sketch\/ns\">';
    if(args.drawFor && args.drawFor == 'profile'){
        svgSizeMarkup = '<svg id=\"svg4\" preserveAspectRatio="xMinYMin meet" viewBox=\"0 0 55 66\" version=\"1.1\" xmlns=\"http:\/\/www.w3.org\/2000\/svg\" xmlns:xlink=\"http:\/\/www.w3.org\/1999\/xlink\" xmlns:sketch=\"http:\/\/www.bohemiancoding.com\/sketch\/ns\">';
    }
    return ''+
      svgSizeMarkup+
      '<title>Van<\/title>'+
      '<desc>Created with Sketch.<\/desc>'+
      '<defs><\/defs>'+
      '<g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">'+
        '<g id=\"Vehicles\" sketch:type=\"MSLayerGroup\" transform=\"translate(6.000000, 6.000000)\">'+
          '<g id=\"Van\">'+
            '<path d=\"M24.8070357,2.06482517 C24.8070357,0.927128915 23.8679812,0 22.7095988,0 L21.3355462,0 C20.1765045,0 19.2381093,0.92445372 19.2381093,2.06482517 L19.2381093,2.84035368 C9.61326938,3.44910139 4.34680048,2.87572654 2.1703667,6.04477612 L0,47.5951992 L2.17036664,47.5951992 L2.17036664,51.8642324 C2.17036664,53.0439961 3.14446402,54 4.34680037,54 L6.52399943,54 C7.72633578,54 8.70111346,53.0439961 8.70111346,51.8642324 L8.70111346,47.5951992 L35.2005519,47.5951992 L35.2005519,51.8642324 C35.2005519,53.0439961 36.1753296,54 37.3782612,54 L39.5560555,53.9999166 C40.7577116,53.9999166 41.7311287,53.0439127 41.7311287,51.864149 L41.7311287,47.5951158 L43.538879,47.5951158 L40.6658655,6.04477612 C39.556055,3.42537313 34.1847955,3.59158205 24.8070357,2.87572659 L24.8070357,2.06482517 Z\" id=\"Shape\" stroke=\"'+args.strokeColor+'\" stroke-width=\"5.11627907\" fill=\"'+args.strokeColor+'\" sketch:type=\"MSShapeGroup\"><\/path>'+
            '<path d=\"M24.8070357,2.06482517 C24.8070357,0.927128915 23.8679812,0 22.7095988,0 L21.3355462,0 C20.1765045,0 19.2381093,0.92445372 19.2381093,2.06482517 L19.2381093,2.84035368 C9.61326938,3.44910139 4.34680048,2.87572654 2.1703667,6.04477612 L0,47.5951992 L2.17036664,47.5951992 L2.17036664,51.8642324 C2.17036664,53.0439961 3.14446402,54 4.34680037,54 L6.52399943,54 C7.72633578,54 8.70111346,53.0439961 8.70111346,51.8642324 L8.70111346,47.5951992 L35.2005519,47.5951992 L35.2005519,51.8642324 C35.2005519,53.0439961 36.1753296,54 37.3782612,54 L39.5560555,53.9999166 C40.7577116,53.9999166 41.7311287,53.0439127 41.7311287,51.864149 L41.7311287,47.5951158 L43.538879,47.5951158 L40.6658655,6.04477612 C39.556055,3.42537313 34.1847955,3.59158205 24.8070357,2.87572659 L24.8070357,2.06482517 Z\" id=\"Shape\" fill=\"'+args.bgColor+'\" sketch:type=\"MSShapeGroup\"><\/path>'+
            '<path d=\"M35.8486939,32.0943396 C33.5709957,32.0943396 31.7209302,33.9070868 31.7209302,36.1426044 C31.7209302,38.3782275 33.5709957,40.1909746 35.8486939,40.1909746 C38.1299395,40.1909746 39.976565,38.3782275 39.976565,36.1426044 C39.976565,33.9071922 38.1299395,32.0943396 35.8486939,32.0943396 L35.8486939,32.0943396 Z\" id=\"Path\" fill=\"'+args.fontColor+'\" sketch:type=\"MSShapeGroup\"><\/path>'+
            '<path d=\"M8.73241478,32.0943396 C6.45213659,32.0943396 4.60465116,33.9070868 4.60465116,36.1426044 C4.60465116,38.3782275 6.45224409,40.1909746 8.73241478,40.1909746 C11.0119405,40.1909746 12.8602859,38.3782275 12.8602859,36.1426044 C12.8602859,33.9071922 11.0119405,32.0943396 8.73241478,32.0943396 L8.73241478,32.0943396 Z\" id=\"Path\" fill=\"'+args.fontColor+'\" sketch:type=\"MSShapeGroup\"><\/path>'+
            '<text id=\"'+vanDriverInitialsPref+'\" fill=\"'+args.fontColor+'\" sketch:type=\"MSTextLayer\" font-family=\"monospace\" font-size=\"19.0\" font-weight=\"normal\" text-align=\"center\" sketch:alignment=\"middle\">'+
              '<tspan x=\"6.0\" y=\"25.1320755\">'+vanDriverInitialsPref+'<\/tspan>'+
            '<\/text>'+
          '<\/g>'+
        '<\/g>'+
      '<\/g>'+
      '<\/svg>';
  }


  makeOutboundAircraftIcon(data: OutboundAircraftAddEvent): L.DivIcon{
    let airplaneStatusClass = '';
    switch(data.outboundAircraftStatus){
      case 'MISSING_CREW': airplaneStatusClass = '<span class="myDivCircle myDivCircleRed"></span>';
      break;
      case 'ALL_DROPPED_OFF': airplaneStatusClass = '<span class="myDivCircle myDivCircleGreen icon-airplane-map-marker "></span>';
      break;
      case 'ASSIGNED': airplaneStatusClass = '<span class="myDivCircle myDivCircleGray icon-airplane-map-marker "></span>';
      break;
      case 'PARTIALLY_DROPPED_OFF': airplaneStatusClass = '<span class="myDivCircle myDivCircleOrange icon-airplane-map-marker "></span>';
      break;
      case 'UNASSIGNED': airplaneStatusClass = '<span class="myDivCircle myDivCircleBlue icon-airplane-map-marker "></span>';
      break;
      default: airplaneStatusClass = '<span class="myDivCircle myDivCircleGray icon-airplane-map-marker "></span>';
      break;
    }
    return L.divIcon({
      className: '',
      html: airplaneStatusClass,
      popupAnchor: [5, 0]
      /* ,iconSize: L.point(44, 44) */
    });

  }


  makeDriverTaskMarkerIcon(primaryOrSecond: string): L.Icon{
    let iconurl = 'assets/images/primaryDropoff.png';
    if(primaryOrSecond === 'second'){
      iconurl = 'assets/images/secondaryLg.png';
    }

    return L.icon({
      iconUrl: iconurl,
      shadowUrl: 'assets/images/primaryDropoffShadow.png',
      iconSize:     [45, 65],
      shadowSize:   [51, 33],
     // iconAnchor:   [22, 94],
      shadowAnchor: [2, -2],
      popupAnchor:  [0, -25]
    });
  }

  makeUnassignedTaskMarkerIcon(): L.DivIcon{
    return L.divIcon({
        className: '',
        html: '<span class="myDivCircle unassignedTaskIcon"><i class="icon-pickup"></i></span>',
        popupAnchor: [5, 0]
      });
  }

  // subscribeToProfile(): void {
  //   this.profileService.getProfileObs().pipe(takeUntil(this.unsubscribe$)).subscribe((profile) => {
  //     if (profile && profile.adId) {
  //       this.adId = profile.adId;
  //     }
  //   });
  // }


}

// <img src="assets/images/outline_north_black_24dp.png">
